// extracted by mini-css-extract-plugin
export default {"page-title":"styles_page-title__QNv1F","section":"styles_section__3ZeUw","notfound":"styles_notfound__2JS8h","text-center":"styles_text-center__bLCuN"};